import useSWRMutation from 'swr/mutation';
import { FetcherArg, fetcherPost } from './httpClient';
import { useAuth } from '../../context/AuthProvider';
import type { EmptyJobRequest } from '../contracts/EmptyJobRequest';

export const useStopJob = (jobId?: string) => {
  const { session } = useAuth();
  const path = jobId ? `jobs/${jobId}/stop` : null;

  return useSWRMutation<
    any,
    Error,
    string | null,
    Omit<FetcherArg<EmptyJobRequest>, 'token'>
  >(path as string, async (url: string, { arg }) =>
    fetcherPost<EmptyJobRequest, any>(url, {
      arg: { ...arg },
      token: session?.access_token ?? '',
    })
  );
};
